import { useEffect } from "react";
import { nanoid } from "nanoid";
import useLogStore from "@/store/logStore";

const useTabManager = () => {
  const { pauseLog, resumeLog } = useLogStore();
  const TAB_KEY = "openTabs";
  const LAST_PAUSED_TAB_KEY = "lastPausedTab";
  let currentTabId = sessionStorage.getItem("tabId");

  if (!currentTabId) {
    currentTabId = nanoid();
    sessionStorage.setItem("tabId", currentTabId);
  }

  useEffect(() => {
    const addTab = () => {
      const tabs = new Set(JSON.parse(localStorage.getItem(TAB_KEY) || "[]"));
      tabs.add(currentTabId);
      localStorage.setItem(TAB_KEY, JSON.stringify([...tabs]));

      const lastPausedTab = localStorage.getItem(LAST_PAUSED_TAB_KEY);
      if (lastPausedTab && lastPausedTab === currentTabId) {
        resumeLog(true);
      }
    };

    const removeTab = () => {
      const tabs = new Set(JSON.parse(localStorage.getItem(TAB_KEY) || "[]"));
      tabs.delete(currentTabId);
      localStorage.setItem(TAB_KEY, JSON.stringify([...tabs]));

      if (tabs.size === 0) {
        pauseLog(true);
        localStorage.setItem(LAST_PAUSED_TAB_KEY, currentTabId);
      }
    };

    addTab();

    window.addEventListener("beforeunload", removeTab);
    window.addEventListener("pagehide", removeTab);

    return () => {
      removeTab();
      window.removeEventListener("beforeunload", removeTab);
      window.removeEventListener("pagehide", removeTab);
    };
  }, [currentTabId]);

  return currentTabId;
};

export default useTabManager;
